import { useState } from 'react'

export const DATA_TABLE_ROWS_PER_PAGE_OPTIONS = [10, 25, 50, 100]

export const DEFAULT_ROWS_PER_PAGE = DATA_TABLE_ROWS_PER_PAGE_OPTIONS[0]

export type DataTableRowsPerPage = {
    rowsPerPage: number
    setRowsPerPage: (rowsPerPage: number) => void
}

export const useDataTableRowsPerPage = (initialRowsPerPage = DEFAULT_ROWS_PER_PAGE): DataTableRowsPerPage => {
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage)

    return { rowsPerPage, setRowsPerPage }
}
